export const environment = {
  name: 'staging',
  version: '190216.0.0',
  production: true,
  API: 'https://tolkify.staging.elevate.ee/api/api/v2',
  clientUrl: 'https://tolkify.staging.elevate.ee/client-app',
  google: {
    key: 'AIzaSyDQMnW_-AFbGCmDjDRSZ3uD4W041pyQ2lw'
  },
  push: {
    oneSignalAppId: '1dbd114b-8fc7-41ca-8691-3129d0f3df77',
    googleProjectId: '82388133381'
  }
};



// WEBPACK FOOTER //
// ./src/app/config/environment.ts